import * as React from 'react';
import { clearHoldListCache } from '../../infrastructure/HoldListCache';
import {
  getLoggedInBruger,
  getLoggedInUniLoginIdToken,
} from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { getLogoutBaseUrl } from '../../infrastructure/LogoutUrlResolver';

export interface LogoutProps {}

class Logout extends React.Component<LogoutProps, any> {
  render() {
    const erEkstern = getLoggedInBruger().rolle === BrugerRolleEnum.Ekstern;
    const uniLoginIdToken = getLoggedInUniLoginIdToken();
    const callbackUrl = window.location.origin + '/auth';
    const logoutBaseUrl = getLogoutBaseUrl();
    localStorage.removeItem('token');
    clearHoldListCache();
    window.location.href = erEkstern
      ? '/'
      : logoutBaseUrl +
        '?post_logout_redirect_uri=' +
        callbackUrl +
        '&id_token_hint=' +
        uniLoginIdToken;
    return <div>Logger ud...</div>;
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/login/Logout.tsx